import { gql } from '@apollo/client'

export default gql`
  fragment EmployeeWithBu on EmployeeWithBusinessUnit {
    id
    firstName
    lastName
    businessUnit {
      id
      name
    }
  }
`
